import apiHelper from "../ApiHelper";

class CustomUploadAdapter {
    constructor(loader, site, folder) {
        // The file loader instance to use during the upload.
        this.loader = loader;
        this.site = site;
        this.folder = folder;
    }

    // Starts the upload process.
    upload() {
        console.log("upload");
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this._sendRequest(resolve, reject, file);
            }));
    }

    // Aborts the upload process.
    abort() {
        if (this.xhr) {
            console.log('abort');
            this.xhr.abort();
        }
    }

    // Prepares the data and sends the request.
    _sendRequest(resolve, reject, file) {
        // Prepare the form data.
        const genericErrorText = `Couldn't upload file: ${file.name}.`;

        if(this.site === 'hknt'){
            apiHelper.hknt.hkntUploadFile(file).then((response) => {
                resolve({
                    default: response.data.url
                });
            })
            .catch(error => {
                console.log(error);
                return reject(error ? error.message : genericErrorText);
            });
        }else if(this.site === 'cineclub'){
            const folder = this.folder || 'MERCHANDISE';
            apiHelper.cineclub.uploadMembershipFile(file, folder).then((response) => {
                resolve({
                    default: response.data.url
                });
            })
            .catch(error => {
                console.log(error);
                return reject(error ? error.message : genericErrorText);
            });
        }else{
            apiHelper.cinefan.uploadFile(file).then((response) => {
                resolve({
                    default: response.data.url
                });
            })
            .catch(error => {
                console.log(error);
                return reject(error ? error.message : genericErrorText);
            });
        }
        

    }
}

function CustomUploadAdapterPlugin(editor) {
    // Try multiple ways to access the config
    let site = editor.config.get ? editor.config.get('site') : (editor.config._config ? editor.config._config.site : undefined);
    let folder = editor.config.get ? editor.config.get('folder') : (editor.config._config ? editor.config._config.folder : undefined);

    // Fallback: try direct access
    if (!site && editor.config._config) {
        site = editor.config._config.site;
    }
    if (!folder && editor.config._config) {
        folder = editor.config._config.folder;
    }

    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new CustomUploadAdapter(loader, site, folder);
    };
}



export default CustomUploadAdapterPlugin;